<template>
  <div class="w-100">
    <Feedback
      :feedback="feedback"
      :dismissible="true"
    />

    <b-button
      v-if="btnRequirementsMet"
      :disabled="isDisabled"
      variant="primary"
      class="w-100"
      @click="handleGenerateViews"
    >
      Genereer aanzichten
    </b-button>
  </div>
</template>

<script>
/**
 * TODO: Write a lambda that handles this server side,
 * TODO: so the file doesn't have to go through the browser?
 * TODO: Q: will timeouts be a factor?
 *
 * TODO: Lacks error handling
 */
import { uploadFile } from '@/services/aws.js'
// getUploadURL,

import { getStreetViewStaticURL } from '@/services/streetview.js'
import { mapGetters, mapMutations } from 'vuex'

import Feedback from '@/components/form/Feedback.vue'

// import Vue from 'vue'

export default {
  name: 'AutomatedViewsBtn',
  components: { Feedback },
  props: {
    uuid: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      busy: false,
      feedback: {
        show: false,
        message: '',
        variant: 'danger',
      },
    }
  },
  computed: {
    ...mapGetters('user', [
      'canAutomateViews',
    ]),
    ...mapGetters('realisation', [
      'recordByUuid',
    ]),
    ...mapGetters('chargingpoints', [
      'getChargingPointByUUID',
    ]),

    /**
     * Records
     */
    record() {
      return this.recordByUuid({ uuid: this.uuid })
    },
    location() {
      try {
        return this.getChargingPointByUUID({
          uuid: this.record.getConnectedLocationUuid(),
        })
      } catch (e) {
        return null
      }
    },

    /**
     * Data requirements & disabled state
     */
    hasLocation() {
      return this.location !== null
    },
    hasCoordinates() {
      return this.hasLocation && this.location.hasCoordinates()
    },
    isDisabled() {
      return this.disabled || this.busy || ! this.hasCoordinates
    },

    hasSideView() {
      return this.record?.hasFileOfCategory({ category: 'sideview' })
      // return this.location.hasDocOfType({ doctype: 'SideView' })
    },
    hasTopView() {
      return this.record?.hasFileOfCategory({ category: 'topview' })
      // return this.location.hasDocOfType({ doctype: 'TopView' })
    },
    btnRequirementsMet() {
      return this.canAutomateViews
        && this.record
        && (! this.hasSideView || ! this.hasTopView)
    },
    isVlaanderen() {
      return process.env.VUE_APP_TENANT === 'vlaanderen'
    },
  },
  methods: {
    ...mapMutations('realisation', [
      'replaceRecord',
    ]),
    ...mapMutations('chargingpoints', [
      'replaceLocation',
    ]),
    async handleGenerateViews() {
      this.busy = true

      let TopViewResult = null
      let SideViewResult = null

      if (! this.hasTopView) {
        TopViewResult = await this.getAndUploadTopView()
      }

      if (! this.hasSideView) {
        SideViewResult = await this.getAndUploadSideView()
      }

      // Neither succeeded
      if (SideViewResult !== true && TopViewResult !== true) {
        // this.feedback = {
        //   show: true,
        //   variant: 'danger',
        //   message: 'Er zijn geen automatische aanzichten beschikbaar',
        // }
        this.$notify({
          error: true,
          title: null,
          message: 'Er zijn geen automatische aanzichten beschikbaar',
        })

        this.busy = false
        return
      }

      // Get fresh copy of the record
      const response = await this.$cbapi.process.getByUuid({
        uuid: this.record.getUuid(),
      })

      if (! response) {
        this.$notify({
          error: true,
          title: 'Synchronisatie mislukt',
          message: 'De status wijziging is opgeslagen, maar het verversen van het record is mislukt.',
        })
        // this.feedback = {
        //   show: true,
        //   variant: 'danger',
        //   message: 'De status wijziging is opgeslagen, maar het verversen van het record is mislukt',
        // }
        this.busy = false
        return
      }

      this.replaceRecord({
        record: response?.data,
      })

      this.$notify({
        success: true,
        title: 'Geslaagd',
        message: 'De automatische aanzichten zijn aangemaakt, en worden over enkele momenten weergegeven.',
      })

      this.busy = false
    },
    async getAndUploadTopView() {
      try {
        const coordinates = this.location.getCoordinates()
        const topviewsService = await import('@/services/topviews.js')
        const url = (this.isVlaanderen)
          ? topviewsService.getVlaanderenSatelite(coordinates)
          : topviewsService.getTopViewUrlFromPDOK(coordinates)

        return await this.uploadView({ doctype: 'topview', url })
      } catch (e) {
        // console.log("unable to obtain top view")
        return false
      }
    },
    async getAndUploadSideView() {
      try {
        const coordinates = this.location.getCoordinates()
        const url = getStreetViewStaticURL(coordinates)

        return await this.uploadView({ doctype: 'sideview', url })
      } catch (e) {
        // console.log("unable to obtain top view")
        return false
      }
    },

    /**
     * Upload a view from a remote url by doctype
     */
    async uploadView({ doctype, url }) {
      if (! url) {
        // console.log("FAIL 1")
        return false
      }

      let response = await fetch(url)

      if (! response.ok) {
        // console.log("FAIL 2", response)
        return false
      }

      const file = await response.blob()

      const filedetails = await this.$cbapi.files.getProcessUploadLink({
        processUuid: this.record.getUuid(),
        category: doctype,
        filename: `${doctype}-${this.record.getCaseRef()}-${this.record.getCurrentIteration()}`,
        extension: 'jpeg',
      })

      if (! filedetails) {
        return false
      }

      const uploadURL = filedetails?.data?.link // response.uploadURL
      response = await uploadFile({ file, uploadURL })

      if (! response.ok) {
        // console.log("FAIL 4", response)
        return false
      }

      return true
    },
  },
}
</script>

<style>

</style>
